export const ObserverProviderKeys = Object.freeze({
  REGISTER_ITEM: Symbol(),
  UNREGISTER_ITEM: Symbol(),
});
